import { defineMessages } from 'react-intl'

// Keyed by service type rather than brand nickname, matching the `service_type` values on the wire.
export const logoMessages = defineMessages({
  autotax: {
    id: 'logo.label.autotax',
    defaultMessage: 'Online könyvelő',
  },
  kaf: {
    id: 'logo.label.quickkeret',
    defaultMessage: 'keret & adófigyelő',
  },
})
